import "./signin.scss";
import { inject, observer } from "mobx-react";
import { useEffect } from "react";

import { Formik } from "formik";
import { Form, Modal } from "react-bootstrap";
import PhoneInputField from "sharedComponents/PhoneInputField";

import { validationsSignIn } from "../../Validation/index";
import cross from "images/cross.svg";

const SignInWithNewPassword = ({
  token,
  loginUser,
  cleanErrorRegistration,
  approvedPhone,
  error,
  setSignInWithNewPasswordModal,
  ...props
}) => {
  useEffect(() => {
    if (approvedPhone === "0") {
      cleanErrorRegistration();
      setSignInWithNewPasswordModal(false);
    }
  });

  if (token) {
    setSignInWithNewPasswordModal(false);
  }
  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      <Modal.Body className="signin">
        <p>
          <img
            src={cross}
            className="signin-img"
            onClick={() => {
              setSignInWithNewPasswordModal(false);
              cleanErrorRegistration();
            }}
            alt=""
          />
        </p>
        <Formik
          initialValues={{
            phone: "",
            password: ""
          }}
          validateOnBlur
          onSubmit={(values) => {
            loginUser(values);
          }}
          validationSchema={validationsSignIn}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            isValid,
            handleSubmit,
            dirty
          }) => (
            <div className="signin-form">
              <Form>
                <p className="registration-form-title">Ваш пароль сброшен!</p>
                <p className="registration-form-title">
                  Пожалуйста, войдите в систему с паролем, который мы выслали на
                  ваш номер телефона
                </p>

                <PhoneInputField name="phone" title="Номер телефона" />

                <Form.Group className="p-2 col-example text-left mb-3">
                  <Form.Label>Новый пароль</Form.Label>
                  <Form.Control
                    type="password"
                    name="password"
                    placeholder="Введите пароль"
                    className="input-form signin-placeholder"
                    isInvalid={touched.password && errors.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.password}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.password}
                  </Form.Control.Feedback>
                </Form.Group>

                <div>
                  <button
                    className="signin-btn"
                    type="submit"
                    disabled={!isValid || !dirty}
                    onClick={handleSubmit}
                  >
                    Войти
                  </button>
                </div>

                {error ? (
                  <p className="signin-form-error">
                    Такого пользователя не существует или пароль введен
                    неправильно
                  </p>
                ) : (
                  ""
                )}
              </Form>
            </div>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default inject(({ usersStore, modalWindows }) => {
  const { token, loginUser, cleanErrorRegistration, approvedPhone, error } =
    usersStore;
  const { setSignInWithNewPasswordModal } = modalWindows;

  return {
    token,
    loginUser,
    cleanErrorRegistration,
    approvedPhone,
    error,
    setSignInWithNewPasswordModal
  };
})(observer(SignInWithNewPassword));
